import { SeedingApplyAcceptBodySchema } from '@musinsa/apis-curator';
import { z } from 'zod';

// 동의 코드 enum/상수는 API 계약에 정의 — 서비스 배럴로 재노출해 Features 가 레이어 스킵 없이 사용.
export {
  SEEDING_REQUIRED_CONSENT_CODES,
  type SeedingConsentCode,
  SeedingConsentCodeSchema,
} from '@musinsa/apis-curator';

export const AcceptSeedingProposalServiceRequestSchema = z
  .object({
    participationId: z.number().int(),
    body: SeedingApplyAcceptBodySchema,
  })
  .describe('AcceptSeedingProposalServiceRequest');

export type AcceptSeedingProposalServiceRequest = z.infer<
  typeof AcceptSeedingProposalServiceRequestSchema
>;

export const AcceptSeedingProposalServiceResponseSchema = z
  .object({
    orderNo: z.string(),
    orderOptionIds: z.array(z.number().int()),
    fulfillmentIds: z.array(z.number().int()),
  })
  .describe('AcceptSeedingProposalServiceResponse');

export type AcceptSeedingProposalServiceResponse = z.infer<
  typeof AcceptSeedingProposalServiceResponseSchema
>;
